import AppProvider from 'providers/AppProvider';
import React from 'react';
import ReactDOM from 'react-dom/client';
import BreakpointsProvider from 'providers/BreakpointsProvider';
import SettingsPanelProvider from 'providers/SettingsPanelProvider';
import { RouterProvider } from 'react-router-dom';
import { router } from 'Routes';
import ChatWidgetProvider from 'providers/ChatWidgetProvider';
import AuthProvider from 'providers/AuthProvider';
import { ToastProvider } from 'pages/thermography/components/ToastProvider';
import PrivateRoute from 'pages/thermography/shared/auth/private-route';

import { Provider } from 'react-redux';
import { bindActionCreators } from 'redux';
import { clearAuthentication } from 'pages/thermography/shared/reducers/authentication';
import { updateLocale } from 'pages/thermography/shared/reducers/locale';
import setupAxiosInterceptors from 'pages/thermography/config/axios-interceptor';
import getStore from 'pages/thermography/config/store';
import './i18n/i18n';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n/i18n';
import { Storage } from 'react-jhipster';

const store = getStore();
store.dispatch(updateLocale(Storage.session.get('locale', 'pt-br')));

const actions = bindActionCreators({ clearAuthentication }, store.dispatch);
setupAxiosInterceptors(() => actions.clearAuthentication('login.error.unauthorized'));

const root = ReactDOM.createRoot(
	document.getElementById('root') as HTMLElement
);
root.render(
	<Provider store={store}>
		<React.StrictMode>
			<I18nextProvider i18n={i18n}>
				<ToastProvider>
					<AppProvider>
						<SettingsPanelProvider>
							<ChatWidgetProvider>
								<BreakpointsProvider>
									<AuthProvider>
										<RouterProvider router={router} />
									</AuthProvider>
								</BreakpointsProvider>
							</ChatWidgetProvider>
						</SettingsPanelProvider>
					</AppProvider>
				</ToastProvider>
			</I18nextProvider>
		</React.StrictMode>
	</Provider>
);
